export const contentDict = {
  title: "PEAKFocus",                // Display name
  finishDate: new Date("2023-06-25"),     // format is YYYY-MM-DD
  tools: {                                // Dict of languages and percentages (should add up to 1)
    "Dart": 0.2,
    "Flutter": 0.4, 
    "Neurofeedback": 0.25, 
  }, 
  description: 
    `This app allows athletes to train their focus in the most important moments of their game. 
    Many athletes internalize a routine to achieve and maintain focus during competitions. 
    Our solution improves the training of these routines by providing feedback from a brain interface..`,
  tags: ["Mobile App", "Hackathon"],
  github: "https://github.com/StartHack-PSFO/PeakFocus",    // Can also be `null`
  website: null,       // Can also be `null`
  images: [
    'https://github.com/StartHack-PSFO/PeakFocus/raw/main/assets/Logo.png',
  ],
  coverImg: 'https://github.com/StartHack-PSFO/PeakFocus/raw/main/assets/Logo.png',
  mainColor: "#000",
  authors: ["Philipp Wulff", "Oliver Klukas", "Shaurya Sharma", "Fabian Mast"],
  isResearch: false,    // Whether should be in the research section
};

